import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-one',
  templateUrl: './two-one.component.html',
  styleUrls: ['./two-one.component.scss']
})
export class TwoOneComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

}
